import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../api/client.js';

export default function TripPlanner() {
  const [days, setDays] = useState(30);
  const [city, setCity] = useState('');

  const list = useQuery({
    queryKey: ['due-for-visit', days, city],
    queryFn: () => api.get('/customers/due-for-visit', { params: { days, city } }).then(r => r.data.data),
  });

  return (
    <div className="space-y-4">
      <header className="flex items-start justify-between gap-2 flex-wrap">
        <div>
          <div className="section-eyebrow">Plan</div>
          <h1 className="text-2xl">Due for visit</h1>
          <div className="rule-crimson" />
          <p className="text-xs text-muted mt-1">Customers in your scope, ranked by how long it's been since any touch.</p>
        </div>
        <Link to="/customers/schedule" className="btn-ghost">🗓️ Build week schedule</Link>
      </header>

      <div className="card p-3 grid grid-cols-2 sm:grid-cols-4 gap-2 items-end">
        <div>
          <label className="label">Untouched for ≥ days</label>
          <select className="input" value={days} onChange={e => setDays(parseInt(e.target.value, 10))}>
            <option value={7}>7</option>
            <option value={14}>14</option>
            <option value={30}>30</option>
            <option value={60}>60</option>
            <option value={90}>90</option>
            <option value={180}>180</option>
          </select>
        </div>
        <div className="sm:col-span-2">
          <label className="label">City contains</label>
          <input className="input" placeholder="City name…"
                 value={city} onChange={e => setCity(e.target.value)} />
        </div>
        <div className="text-right text-sm text-muted self-center">
          {list.data?.length || 0} customers
        </div>
      </div>

      <div className="space-y-1">
        {list.isLoading && <div className="text-muted">Loading…</div>}
        {list.data?.length === 0 && <div className="text-muted">All caught up at this threshold.</div>}
        {list.data?.map(c => (
          <Link key={c.id} to={`/customers/${c.id}`}
                className="card p-3 flex items-baseline justify-between hover:ring-1 hover:ring-crimson">
            <div>
              <div className="font-medium">{c.name}</div>
              <div className="text-xs text-muted">
                {[c.city, c.state].filter(Boolean).join(', ') || '—'}
                {c.phone && <> · 📞 {c.phone}</>}
              </div>
            </div>
            <div className="text-right text-sm">
              <div className={c.days_since_touch > 90 ? 'text-crimson font-semibold' : 'text-navy'}>
                {c.last_at ? `${c.days_since_touch}d touch` : 'never touched'}
              </div>
              <div className="text-xs text-muted">
                {c.last_visit_at ? `${c.days_since_visit}d visit` : 'no visit'}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
